import cn from 'classnames'
import React, { ComponentProps } from 'react'

type UsersCheckIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function UsersCheckIcon(props: UsersCheckIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('UsersCheckIcon', className)}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect x="0.5" width="24" height="24" rx="4" fill="#EBF2FE" />
      <path
        d="M15.1667 16L16.5 17.3333L19.1667 14.6667M12.5 14H9.83334C8.59083 14 7.96958 14 7.47952 14.203C6.82611 14.4736 6.30698 14.9928 6.03633 15.6462C5.83334 16.1362 5.83334 16.7575 5.83334 18M14.8333 6.19384C15.8106 6.58943 16.5 7.54754 16.5 8.66667C16.5 9.78579 15.8106 10.7439 14.8333 11.1395M13.5 8.66667C13.5 10.1394 12.3061 11.3333 10.8333 11.3333C9.36058 11.3333 8.16668 10.1394 8.16668 8.66667C8.16668 7.19391 9.36058 6 10.8333 6C12.3061 6 13.5 7.19391 13.5 8.66667Z"
        stroke="#4489F9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
